module.exports = __webpack_public_path__ + "img/profileMan.055a9197.png";